import { COLUMN_DISPLAY_NAME, COLUMN_FIRST_NAME, COLUMN_SECOND_NAME, COLUMN_LAST_NAME, COLUMN_COMPANY, COLUMN_DEPARTMENT, COLUMN_TITLE, COLUMN_UNIQUE_IDENTIFIER, COLUMN_SITE, COLUMN_DATE, COLUMN_DAYS, REPORTS_COLUMN_HOURS_WORKED, COLUMN_PROFILE, COLUMN_SHIFT_TYPE, COLUMN_DAYS_WORKED, COLUMN_TOTAL_HOURS_WORKED, COLUMN_AVG_HOURS_PER_DAY, COLUMN_AVG_FIRST_IN_TIME, COLUMN_AVG_LAST_OUT_TIME, COLUMN_FIRST_IN, COLUMN_LAST_OUT, COLUMN_TIME_SPAN, COLUMN_SEGMENTS, COLUMN_NOTES } from "../../constants/column-types";
import { FILTER_COMPANIES, FILTER_DEPARTMENTS, FILTER_SITES, FILTER_DATE, FILTER_TAGHOLDERS } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const HoursWorkedReportColumn: TableColumn[] = [
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 0,
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE,
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        sortDirection: "asc",
        sortByName: "mstDisplayname",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "displayName",
        isDefault: true,
        columnId: COLUMN_DISPLAY_NAME,
        lookupName: "mstDisplayname",
        searchOnName: "masterId",
        filterId: FILTER_TAGHOLDERS,
        settingDataName: 'master',
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 2,
        sortByName: "mstFirstname",
        sortDirection: "asc",
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 3,
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 4,
        sortByName: "mstLastname",
        sortDirection: "asc",
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME
    },
    {
        heading: "Unique Identifier",
        accessor: "idNumber",
        isNumeric: false,
        id: 5,
        active: false,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    // --- Parent summary columns ---
    {
        heading: "Shift Type",
        accessor: "shiftType",
        isNumeric: false,
        id: 18,
        active: true,
        translationKey: "shiftType",
        isDefault: true,
        columnId: COLUMN_SHIFT_TYPE,
    },
    {
        heading: "Days Worked",
        accessor: "daysWorked",
        isNumeric: true,
        id: 19,
        active: true,
        translationKey: "daysWorked",
        columnId: COLUMN_DAYS_WORKED,
        isDefault: true,
    },
    {
        heading: "Total Hours Worked",
        accessor: "totalHoursWorked",
        isNumeric: false,
        id: 20,
        active: true,
        translationKey: "totalHoursWorked",
        isDefault: true,
        columnId: COLUMN_TOTAL_HOURS_WORKED,
    },
    {
        heading: "Avg Hours/Day",
        accessor: "avgHoursPerDay",
        isNumeric: false,
        id: 21,
        active: true,
        isDefault: true,
        translationKey: "avgHoursPerDay",
        columnId: COLUMN_AVG_HOURS_PER_DAY,
    },
    {
        heading: "Avg First In",
        accessor: "avgFirstInTime",
        isNumeric: false,
        id: 22,
        active: true,
        isDefault: true,
        translationKey: "avgFirstInTime",
        columnId: COLUMN_AVG_FIRST_IN_TIME,
    },
    {
        heading: "Avg Last Out",
        accessor: "avgLastOutTime",
        isNumeric: false,
        id: 23,
        active: true,
        isDefault: true,
        translationKey: "avgLastOutTime",
        columnId: COLUMN_AVG_LAST_OUT_TIME,
    },
    // --- Child (dailyDetails) columns ---
    {
        heading: "Date",
        accessor: "dateOnly",
        isNumeric: false,
        id: 6,
        searchOnName: "dateOnly",
        sortByName: "dateOnly",
        active: true,
        translationKey: "dateOnly",
        columnId: COLUMN_DATE,
        filterId: FILTER_DATE,
        settingDataName: "date",
        hideLookup: true,
        valueFormatting: () => 'whitespace-nowrap'
    },
    {
        heading: "Day of Week",
        accessor: "dayOfWeek",
        isNumeric: false,
        id: 7,
        active: true,
        translationKey: "dayOfWeek",
        isDefault: true,
        columnId: COLUMN_DAYS
    },
    {
        heading: "First In",
        accessor: "firstIn",
        isNumeric: false,
        id: 24,
        active: true,
        translationKey: "firstIn",
        columnId: COLUMN_FIRST_IN,
    },
    {
        heading: "Last Out",
        accessor: "lastOut",
        isNumeric: false,
        id: 25,
        active: true,
        translationKey: "lastOut",
        columnId: COLUMN_LAST_OUT,
    },
    {
        heading: "Hours Worked",
        accessor: "hoursWorked",
        isNumeric: false,
        id: 8,
        active: true,
        isDefault: true,
        translationKey: "hoursWorked",
        columnId: REPORTS_COLUMN_HOURS_WORKED
    },
    {
        heading: "Time Span",
        accessor: "timeSpan",
        isNumeric: false,
        id: 26,
        active: false,
        translationKey: "timeSpan",
        columnId: COLUMN_TIME_SPAN,
    },
    {
        heading: "Segments",
        accessor: "segments",
        isNumeric: false,
        id: 27,
        active: true,
        translationKey: "segments",
        isDefault: true,
        columnId: COLUMN_SEGMENTS,
    },
    {
        heading: "Notes",
        accessor: "notes",
        isNumeric: false,
        id: 28,
        active: true,
        translationKey: "notes",
        isDefault: true,
        columnId: COLUMN_NOTES,
    },
    // --- Relationship columns (display + filter) ---
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 10,
        searchOnName: "companyId",
        lookupName: "company.id",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: 'company'
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 11,
        active: false,
        searchOnName: "departmentId",
        lookupName: "department.id",
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: 'department'
    },
    {
        heading: "Category",
        accessor: "profileName",
        isNumeric: false,
        id: 12,
        searchOnName: "profileId",
        lookupName: "profile.id",
        active: false,
        translationKey: "category",
        columnId: COLUMN_PROFILE,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 13,
        searchOnName: "siteId",
        lookupName: "site.id",
        active: true,
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: 'site'
    },
]

export default HoursWorkedReportColumn;
